import React from "react";
import VenuesList from "../../Venues/VenuesList";

const Venues = () => {
  return (
    <>
      <div className={"mb-2"}>
        <VenuesList />
      </div>
    </>
  );
};

export default Venues;
